var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"bin-manifest-page\">\n<h2>Bin Manifest Page</h2>\n</div>\n";
var id1="bin_manifest.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./client/app/components/branch_management/components/bin_manifest/bin_manifest.html
// module id = 2667
// module chunks = 1